import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { rebuildReactTooltip } from '@bpm-web-app/utils';
import { AppLink } from '../shared/app-link/app-link';
import BPMIcons from '../shared/bpm-icons/bpm-icons';
import { TOAST_DISMISS_TOOLTIP_ID } from '../app-toast/app-toast';
import styles from './toast-close-button.module.css';

interface ToastCloseButtonProps {
    title?: string;
    onClick?: () => void;
    closeToast?: () => void;
    routeOnClick?: string;
    replaceRouteOnClick?: string;
}

export function ToastCloseButton({ title, onClick, routeOnClick, replaceRouteOnClick, closeToast }: ToastCloseButtonProps) {
    const router = useRouter();

    useEffect(() => {
        rebuildReactTooltip();
    }, []);

    return (
        <div className={styles['toast-close-button']}>
            {title
                ? replaceRouteOnClick
                    ?
                    (
                        <AppLink href={replaceRouteOnClick}>
                            <a
                                className={styles['toast-close-button--title']}
                            >
                                {title}
                            </a>
                        </AppLink>
                    )
                    :
                    (
                        <button
                            className={styles['toast-close-button--title']}
                            type="button"
                            onClick={() => {
                                if (onClick) onClick();
                                if (routeOnClick) router.push(routeOnClick);
                            }}
                        >
                            {title}
                        </button>
                    )
                : null
            }
            <button
                type="button"
                className={styles['toast-close-button--close-button']}
                aria-label="Dismiss"
                data-for={TOAST_DISMISS_TOOLTIP_ID}
                data-tip="Dismiss"
                data-tip-show
                data-class="toast-dismiss-tooltip"
                onClick={closeToast}
            >
                <BPMIcons.CloseIcon />
            </button>
        </div>
    );
}
